module.exports = __webpack_public_path__ + "img/fitintime_logo.65035a20.svg";